import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { RenderIf } from "../../utils/RenderIf";

import logo from './logo.png';

export default function HeaderSection({ S, data, doc_type }) {
    return (
        <View style={S.header}>

            {/* LOGO IZQUIERDA */}

            {/* <View >
                <Image
                    style={S.imageLogo}
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0iDqgVxapcAcUfyo08JC1g6pWv1ZWh0Vt4Q&s" />
            </View> */}

            <View style={S.imageContainer}>
                <Image
                    src={logo}
                    style={S.imageFit}
                />
            </View>


            {/* TITULO CENTRADO REAL */}
            <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
                {/* <Text style={[S.brandTitle, { textAlign: "center" }]}>
          Factura
        </Text> */}



                <Text style={[S.brandTitle, { textAlign: "center" }]}>
                    <RenderIf isTrue={doc_type === "invoice"}>
                        Comprobante Auxiliar de Factura Electrónica
                    </RenderIf>

                    <RenderIf isTrue={doc_type === "credit_note"}>
                        Comprobante Auxiliar de Nota de credito
                    </RenderIf>
                </Text>
                <Text style={[S.brandTitle, { textAlign: "center" }]}>

                    <RenderIf isTrue={doc_type === 'invoice'}>
                        Factura de Operación Interna
                    </RenderIf>

                    <RenderIf isTrue={doc_type === 'credit_note'}>
                        Nota de credito referenta a una o varias FE
                    </RenderIf>
                </Text>
            </View>

        </View>
    );
}